<template>
    <v-tab-item :value="$route.path" class="pa-3">
        <v-toolbar flat height="90">
            <v-btn
                color="secondary"
                class="text-capitalize px-5"
                depressed
                v-text="translations.addProduct[lang]"
                @click="openProductDialog('create', {})"
            ></v-btn>
        </v-toolbar>
        <v-row no-gutters justify="end" class="px-4 pb-3 align-end">
            <div class="mr-auto"></div>

            <v-col cols="4" class="pa-0">
                <b-search-field v-model="search"></b-search-field>
            </v-col>
        </v-row>

        <b-data-table
            :headers="headers"
            :items="products"
            :page.sync="page"
            :pagination="productsPagination"
            @page-sync="p => (page = p)"
            :loading="loading"
            disable-sort
            class="b-outlined"
        >
            <template v-slot:item.image_url="{ item }">
                <v-img
                    :src="item.image_url"
                    width="70"
                    v-if="item.image_url"
                ></v-img>
                <div v-else>-</div>
            </template>
            <template v-slot:item.subscription_product_type_id="{ item }">
                <div v-if="item.subscription_product_type_id">
                    {{ getProductType(item) }}
                </div>
                <div v-else>-</div>
            </template>
            <template v-slot:item.stores="{ item }">
                <div
                    v-if="
                        !item.store_ids.length ||
                            item.stores.length == companies.length - 1
                    "
                    class="pb-1"
                >
                    <span> {{ translations.all[lang] }}</span>
                </div>
                <div v-else-if="item.stores.length > 15" class="pb-1">
                    <span
                        >{{ item.stores.length }}
                        {{ translations.storesSelected[lang] }}</span
                    >
                    <v-tooltip color="secondary" top>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                class="ml-2 pb-1"
                                icon
                                x-small
                                v-on="on"
                                @click="openCompanyList(item.stores)"
                            >
                                <v-icon>...</v-icon>
                            </v-btn>
                        </template>

                        <span
                            class="font-weight-bold"
                            v-text="translations.show[lang]"
                        ></span>
                    </v-tooltip>
                </div>
                <div v-else class="pb-1">
                    <v-chip
                        v-for="store in item.stores"
                        :key="store.store_id"
                        small
                        class="mt-1 mr-1"
                    >
                        {{ store.store_name }}
                    </v-chip>
                </div>
            </template>
            <template v-slot:item.variants="{ item }">
                <div v-if="item.variants.length" class="pb-1">
                    <v-chip
                        v-for="variant in item.variants"
                        :key="variant.subscription_product_variant_id"
                        small
                        class="mt-1 mr-1"
                    >
                        {{ variant.name[lang] }}
                    </v-chip>
                </div>
                <div v-else class="pb-1">
                    <span> - </span>
                </div>
            </template>
            <template v-slot:item.variants_count="{ item }">
                <span v-if="item.variants.length > 1"
                    >{{
                        Math.min(
                            ...item.variants.map(variant => variant.price)
                        ).toFixed(2)
                    }}
                    -
                    {{
                        Math.max(
                            ...item.variants.map(variant => variant.price)
                        ).toFixed(2)
                    }}</span
                >
                <span v-else-if="item.variants[0]">{{
                    item.variants[0].price || "-"
                }}</span>
                <span v-else>-</span>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-tooltip color="secondary" top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            color="yellow darken-3"
                            icon
                            v-on="on"
                            @click="openProductDialog('update', item)"
                        >
                            <v-icon v-text="icons.mdiPencilOutline"></v-icon>
                        </v-btn>
                    </template>

                    <span
                        class="font-weight-bold"
                        v-text="translations.update[lang]"
                    ></span>
                </v-tooltip>

                <v-tooltip color="secondary" top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            color="red"
                            icon
                            v-on="on"
                            @click="
                                () => {
                                    product = item;
                                    deleteDialog = true;
                                }
                            "
                        >
                            <v-icon v-text="icons.mdiClose"></v-icon>
                        </v-btn>
                    </template>

                    <span
                        class="font-weight-bold"
                        v-text="translations.delete[lang]"
                    ></span>
                </v-tooltip>
            </template>
        </b-data-table>

        <v-dialog v-model="productDialog" max-width="600">
            <SubscriptionProductForm
                :mode="mode"
                @cancel="productDialog = false"
            />
        </v-dialog>

        <v-dialog v-model="deleteDialog" max-width="500">
            <b-card
                type="delete"
                :title="translations.deleteProduct[lang]"
                :submit-text="translations.delete"
                :loading="loading"
                :error-message="errorMessage"
                @cancel="deleteDialog = false"
                @submit="deleteProduct()"
            >
                <div class="subtitle-1 font-weight-medium pt-2 px-2">
                    {{ translations.deleteConfirmationMessage[lang] }}
                    <span class="font-weight-bold text--primary">{{
                        product.name[lang]
                    }}</span
                    >{{ translations.questionmark[lang] }}
                </div>
            </b-card>
        </v-dialog>

        <v-dialog v-model="listDialog" max-width="500">
            <b-card
                :title="translations.companies[lang]"
                @cancel="closeCompanyList()"
                :submitBtn="false"
                :loading="loading"
            >
                <v-list three-line>
                    <template v-for="(item, index) in listItems">
                        <v-divider
                            v-if="index"
                            :key="index + 'f'"
                            inset
                        ></v-divider>

                        <v-list-item :key="index" class="d-flex align-center">
                            <span class="text-h6 pa-2 text-center"
                                >{{ index + 1 }}.</span
                            >
                            <v-list-item-content>
                                <v-list-item-title class="text-h5 text-center"
                                    ><span v-if="item.store_code"
                                        >[{{ item.store_code }}]</span
                                    >
                                    <span>{{ item.store_name }}</span>
                                </v-list-item-title>
                                <v-list-item-subtitle class="text-center"
                                    >ID:
                                    {{ item.store_id }}</v-list-item-subtitle
                                >
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-list>
            </b-card>
        </v-dialog>
    </v-tab-item>
</template>

<script>
import { mdiPencilOutline, mdiClose } from "@mdi/js";

import { mapState, mapMutations, mapActions } from "vuex";
import debounce from "lodash/debounce";
import SubscriptionProductForm from "@/components/general/settings/roadcubeMarket/SubscriptionProductForm.vue";
import translations from "@/utils/translations/general/settings/roadcubeMarket";
import { cloneDeep } from "lodash";

export default {
    name: "SubscriptionProducts",

    components: { SubscriptionProductForm },

    mixins: [translations],

    data() {
        return {
            icons: { mdiPencilOutline, mdiClose },

            page: +this.$route.query.page,
            mode: "create",
            search: "",
            productDialog: false,
            deleteDialog: false,
            listItems: [],
            listDialog: false
        };
    },

    computed: {
        ...mapState(["loading", "errorMessage", "userStores"]),

        ...mapState("general/settings/roadcubeMarket/subscriptionProducts", [
            "products",
            "productsPagination",
            "productTypes"
        ]),

        lang() {
            return this.$route.params.lang;
        },

        headers() {
            return [
                {
                    text: this.translations.image[this.lang],
                    value: "image_url"
                },
                {
                    text: this.translations.productName[this.lang],
                    value: `name['${this.lang}']`
                },
                {
                    text: this.translations.productDescription[this.lang],
                    value: `description['${this.lang}']`
                },
                {
                    text: this.translations.productType[this.lang],
                    value: `subscription_product_type_id`
                },
                {
                    text: this.translations.companies[this.lang],
                    value: "stores",
                    width: "500"
                },
                {
                    text: this.translations.variants[this.lang],
                    value: "variants"
                },
                {
                    text: this.translations.price[this.lang],
                    value: "variants_count"
                },

                {
                    text: this.translations.actions[this.lang],
                    value: "actions"
                }
            ];
        },
        companies() {
            return (
                this.userStores?.filter(e => e.name?.includes("Company: ")) ||
                []
            );
        },
        product: {
            get() {
                return this.$store.state.general.settings.roadcubeMarket
                    .subscriptionProducts.product;
            },

            set(val) {
                this.setProduct(val);
            }
        },

        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }

            return query.slice(0, query.length - 1);
        }
    },

    methods: {
        ...mapMutations([
            "setDialog",
            "setDeleteDialog",
            "setResetSuccess",
            "setResetValidation"
        ]),
        ...mapMutations(
            "general/settings/roadcubeMarket/subscriptionProducts",
            ["setProduct"]
        ),
        ...mapActions("general/settings/roadcubeMarket/subscriptionProducts", [
            "getProducts",
            "deleteProduct",
            "getProductTypes"
        ]),
        ...mapActions(["getUserStores"]),

        openProductDialog(mode, item) {
            this.mode = mode;
            this.product = cloneDeep(item);
            this.productDialog = true;
        },

        async deleteItem() {
            let res = await this.delete(this.product.subscription_product_id);
            if (res) {
                await this.getProducts(this.query);
                this.deleteDialog = false;
                this.setProduct();
            }
        },

        handleSearch() {
            if (this.page != 1) {
                this.page = 1;
            } else {
                this.getProducts(`?q=${this.search}`);
            }
        },

        getProductType(product) {
            let type =
                this.productTypes?.find(
                    x =>
                        x.subscription_product_type_id ==
                        product.subscription_product_type_id
                ) || {};
            return type.name?.[this.lang] || "-";
        },
        openCompanyList(items) {
            this.listItems = items;
            this.listDialog = true;
        },
        closeCompanyList() {
            this.listDialog = false;
            this.listItems = [];
        }
    },

    watch: {
        $route(val) {
            if (!val.query.page) {
                this.$router.replace({
                    query: {
                        page: 1,
                        ...this.$route.query
                    }
                });
            }
            this.getProducts(`${this.query}&q=${this.search}`);
        },

        page(page) {
            this.$router.replace({ query: { ...this.$route.query, page } });
        },

        search(val) {
            if (val == null) {
                this.getProducts(this.query);
            } else {
                this.debouncedSearch();
            }
        },

        exportedFile(val) {
            if (val) {
                if (val.queue) {
                    this.exportCsvStatus = 2;
                } else {
                    this.exportCsvStatus = 3;
                }
            } else {
                this.exportCsvStatus = 1;
            }
        },

        exportCSVStatus(val) {
            if (val) {
                this.exportCsvStatus = 3;
                this.setExportCSVStatus(false);
            }
        }
    },

    beforeCreate() {
        if (!this.$route.query.page) {
            this.$router.replace({
                query: {
                    page: 1,
                    ...this.$route.query
                }
            });
        }
    },

    created() {
        this.debouncedSearch = debounce(this.handleSearch, 500);
    },

    mounted() {
        this.getProducts(this.query);
        if (!this.productTypes?.length) {
            this.getProductTypes();
        }
        if (!this.userStores?.length) {
            this.getUserStores();
        }
    }
};
</script>
<style>
.csv-input * {
    cursor: pointer;
}
</style>
